import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { UtilsService } from 'src/app/common';

@Component({
  selector: 'gig-base-search-results',
  standalone: true,
  imports: [CommonModule, TableModule],
  template: `
    <p>
      base-search-results works!
    </p>
  `,
  styles: [
  ]
})
export class BaseSearchResultsComponent implements OnInit {

  public selectedResults: Array<any>;

  public cols: Array<any>;

  @Input() searchResults: Array<any>;
  @Input() target: string;

  @ViewChild('dt') resultTable: Table;

  // Pagination state preservation
  private savedPaginationState: { first: number, rows: number } = null;

  constructor(public utils: UtilsService) { }

  ngOnInit(): void {
  }

  public clearTable(): void {
    this.utils.logger.info('BaseSearchResultsComponent.clearTable() ');
    this.selectedResults = [];
    this.resultTable.clear();
  }

  public clearTablePreservePagination(): void {
    this.utils.logger.info('BaseSearchResultsComponent.clearTablePreservePagination() ');
    // Save current pagination state before clearing
    this.savePaginationState();
    this.selectedResults = [];
    // Don't call resultTable.clear() or reset() to preserve pagination
  }

  public savePaginationState(): void {
    if (this.resultTable) {
      this.savedPaginationState = {
        first: this.resultTable.first || 0,
        rows: this.resultTable.rows || 30
      };
      this.utils.logger.info('BaseSearchResultsComponent.savePaginationState() ', this.savedPaginationState);
    }
  }

  public restorePaginationState(): void {
    if (this.resultTable && this.savedPaginationState) {
      this.utils.logger.info('BaseSearchResultsComponent.restorePaginationState() ', this.savedPaginationState);
      setTimeout(() => {
        this.resultTable.first = this.savedPaginationState.first;
        this.savedPaginationState = null;
      }, 0);
    }
  }

  get getSelectedSearchResults(): Array<any> {
    return this.selectedResults;
  }

}
